
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/sadhguru-schedule",
      function () {
        return require("private-next-pages/[region]/[language]/sadhguru-schedule/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/sadhguru-schedule"])
      });
    }
  